import { memo } from 'react'
import { useIsMobile } from '../Responsive'
// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import MaterialBox from '@mui/material/Box'
import useStyles from './styles'

export type Props = ComponentProps<typeof MaterialBox> & {
  children?: React$Node
  className?: string,
  disabled?: boolean,
  testID?: string
  lightBorder?: boolean,
  mobileOnly?: boolean,
}

const Box = memo<Props>(({
  children,
  className,
  disabled = false,
  lightBorder = false,
  mobileOnly = false,
  testID,
  ...props
}) => {
  const isMobile = useIsMobile()
  const { classes, cx } = useStyles()

  if (mobileOnly && !isMobile) {
    return (<>
      { children }
    </>)
  }

  return (<MaterialBox
    className={cx({
      [classes.disabled]: disabled,
      [classes.lightBorder]: lightBorder,
    },
    className,
    )}
    data-test-id={testID}
    {...props}
  >
    {
      children
    }
  </MaterialBox>)
})

Box.displayName = 'Box'

export default Box
